import React, { useCallback, useMemo } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { useTranslation } from 'react-i18next'
import { conditionTypes, MIN_SCANS_INTERVAL } from 'consts/automatedActionConsts'
import ErrorMessage from 'components/common/text/ErrorMessage'

const useStyles = makeStyles({
  intervalInput: {
    outline: 'none',
    fontSize: 16,
    textAlign: 'center',
    height: 32,
    width: 80,
    border: 'none',
    borderBottom: ({ errorMessage }) => (errorMessage ? '1px solid red' : '1px solid var(--border-color-11)'),
    paddingLeft: 14
  }
})

const PatientScanCountEveryCondition = ({ onChange, params, errors }) => {
  const errorMessage = useMemo(() => errors.conditions?.[conditionTypes.PatientScanCountEvery], [errors])
  const classes = useStyles({ errorMessage })
  const { t } = useTranslation()

  const handleChange = useCallback(
    scansInterval => {
      onChange({
        type: conditionTypes.PatientScanCountEvery,
        params: { scansInterval }
      })
    },
    [onChange]
  )

  return (
    <Grid container direction="column">
      <Grid item>
        <Grid container alignItems="center">
          <Grid item>
            <DazzedParagraph14 strong>
              {t('pages.accountSettings.automations.editorModal.enterScansInterval')}
            </DazzedParagraph14>
          </Grid>
          <Grid item>
            <input
              value={params?.scansInterval || ''}
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder={t('pages.accountSettings.automations.editorModal.enterScansIntervalPlaceholder')}
              className={classes.intervalInput}
              onChange={({ target }) => handleChange(target.value)}
              min={MIN_SCANS_INTERVAL}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>{errorMessage && <ErrorMessage text={errorMessage} active={!!errorMessage} />}</Grid>
    </Grid>
  )
}

export default PatientScanCountEveryCondition
